import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../cms/block/abstract-cms-block.component';

export interface IBasketKlarnaContentBlock extends NICmsContentComponent.IData {
    text?: string;
    image?: string;
    ratio?: string;
}

/**
 * Component definition
 */
@Component({
    selector: 'basket-klarna-content-block',
    templateUrl: './basket-klarna-content-block.html',
    standalone: true,
    imports: [CommonModule, DfImageDirective, ICmsClientModule]
})
@ICmsComponent<BasketKlarnaContentBlockComponent>({
    id: 'basket-klarna-content-block',
    block: {
        url: 'basket-klarna-content-block'
    },
    onDemandOnly: true,
    name: 'Basket Klarna Content Block',
    description: 'Content block used on the search component',
    fields: [
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'text',
            title: 'Text',
            description: 'Appears where listing posts'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image',
            default: ''
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1'
        }
    ]
})
export class BasketKlarnaContentBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IBasketKlarnaContentBlock;
}
